import React, { useState } from 'react';
import { collection, query, where, getDocs, addDoc, updateDoc, doc } from 'firebase/firestore';
import { auth, db } from '../../../Config/Config';
import { Client, Storage, ID } from 'appwrite';
import { FaUpload, FaFileAlt, FaSpinner } from 'react-icons/fa';
import './UploadPage.css';

const UploadPage = ({ amount, onShowModal }) => {
  const [file, setFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState('');
  const [dragActive, setDragActive] = useState(false);
  const [loading, setLoading] = useState(false);

  const client = new Client();
  client
    .setEndpoint('https://cloud.appwrite.io/v1')
    .setProject('6828497c0009c8c2c5c8');

  const storage = new Storage(client);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setUploadStatus('File ready to upload');
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    const selectedFile = e.dataTransfer.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setUploadStatus('File ready to upload');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    const user = auth.currentUser;
    if (!user) {
      setLoading(false);
      onShowModal('User not authenticated.');
      return;
    }
  
    if (file) {
      try {
        setUploadStatus('Uploading your file. Please wait...');
  
        const response = await storage.createFile(
          '682849b500249808a69a',
          ID.unique(),
          file
        );
  
        const fileId = response.$id;
        const fileUrl = storage.getFileView('682849b500249808a69a', fileId);
  
        const userQuery = query(collection(db, 'users'), where('uid', '==', user.uid));
        const userSnapshot = await getDocs(userQuery);
  
        if (userSnapshot.empty) {
          onShowModal('User details not found in the database.');
          return;
        }
  
        const userData = userSnapshot.docs[0].data();
        const {firstName, lastName } = userData;
  
        const depositQuery = query(collection(db, 'deposits'), where('uid', '==', user.uid));
        const depositSnapshot = await getDocs(depositQuery);
  
        if (!depositSnapshot.empty) {
          const depositDoc = depositSnapshot.docs[0];
          await updateDoc(doc(db, 'deposits', depositDoc.id), {
            amount,
            proofOfPayment: fileUrl,
            status: 'pending',
            firstName,
            lastName,
            
          });
        } else {
          await addDoc(collection(db, 'deposits'), {
            uid: user.uid,
            amount,
            TotalAmount: 0,
            proofOfPayment: fileUrl,
            status: 'pending',
            firstName,
            lastName,
            createdAt: new Date(),
          });
        }
  
        setUploadStatus('Upload successful!');
        onShowModal('Your file has been uploaded successfully, and the deposit is registered.');
        setFile(null);
      } catch (error) {
        setLoading(false);
        onShowModal(`File upload failed: ${error.message}`);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
      onShowModal('Please select a file before uploading.');
    }
  };

  return (
    <div className="btc-deposit-upload-container">
      <div className="btc-deposit-upload-card">
        <div className="btc-deposit-upload-header">
          <h3 className="btc-deposit-upload-title">Upload Proof of Payment</h3>
          <p className="btc-deposit-upload-subtitle">Upload your payment receipt for verification</p>
        </div>
        
        <form onSubmit={handleSubmit} className="btc-deposit-upload-form">
          <div
            className={`btc-deposit-dropzone ${dragActive ? 'btc-deposit-dropzone-active' : ''}`}
            onDragOver={handleDragOver}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <input
              type="file"
              id="btc-deposit-file-input"
              accept="image/*,application/pdf"
              onChange={handleFileChange}
              className="btc-deposit-file-input"
            />
            <label htmlFor="btc-deposit-file-input" className="btc-deposit-file-label">
              {file ? (
                <div className="btc-deposit-file-preview">
                  <FaFileAlt className="btc-deposit-file-icon" />
                  <span className="btc-deposit-file-name">{file.name}</span>
                </div>
              ) : (
                <div className="btc-deposit-upload-content">
                  <FaUpload className="btc-deposit-upload-icon" />
                  <p className="btc-deposit-upload-instructions">
                    Drag and drop your file here, or click to browse
                  </p>
                  <p className="btc-deposit-upload-hint">
                    Supported formats: JPG, PNG, PDF (Max 5MB)
                  </p>
                </div>
              )}
            </label>
          </div>
          
          {uploadStatus && (
            <p className={`btc-deposit-status-message ${
              uploadStatus.includes('success') ? 'btc-deposit-status-success' : 
              uploadStatus.includes('ready') ? 'btc-deposit-status-info' : 'btc-deposit-status-error'
            }`}>
              {uploadStatus}
            </p>
          )}
          
          <button
            type="submit"
            className={`btc-deposit-upload-button ${loading ? 'btc-deposit-upload-button-loading' : ''}`}
            disabled={loading || !file}
          >
            {loading ? (
              <>
                <FaSpinner className="btc-deposit-spinner" />
                Uploading...
              </>
            ) : 'Upload Payment Proof'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UploadPage;